<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    lazy
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Dados da Tabulação</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline"
                >{{ type === "new" ? "Adicionar" : "Editar" }} Tabulação</span
              >
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md5 mr-4>
                    <v-text-field
                      label="Nome da Tabulação"
                      v-model="name"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o nome da tabulação.',
                      ]"
                      required
                    ></v-text-field>
                    <v-text-field
                      label="ID da Tabulação"
                      v-model="id"
                      :rules="[
                        (v) =>
                          !!v || 'Por favor, coloque um ID para a tabulação.',
                      ]"
                      required
                      :readonly="type === 'edit'"
                    ></v-text-field>
                    <v-checkbox
                      label="Finaliza o lead?"
                      v-model="finishLead"
                      required
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="error" @click="dialog = false"> Fechar </v-btn>
              <v-btn
                flat
                color="success"
                @click="validate()"
                :loading="loading"
                :disabled="buttonDisable()"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { eventBus } from "@/main";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    valid: false,
    rules: [],
    dialog: false,
    type: "new",
    name: "",
    id: "",
    finishLead: false,
  }),

  computed: {
    ...mapState("configuration", ["loading"]),
  },

  mounted() {
    eventBus.$on("tabulationForm", (obj) => {
      if (obj.type === "edit") {
        this.name = obj.data.name;
        this.id = obj.data.id;
        this.finishLead = obj.data.finishLead;
      } else if (obj.type === "new") {
        this.name = "";
        this.id = "";
        this.finishLead = false;
      }
      this.type = obj.type;
      this.dialog = obj.status;
    });
  },

  methods: {
    ...mapActions("configuration", ["addTabulation", "updateTabulation"]),

    buttonDisable() {
      return !this.valid || this.name === "" || this.id === "";
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        const data = {
          name: this.name,
          id: this.id,
          finishLead: this.finishLead,
          status: "activated",
        };

        if (this.type === "new") {
          await this.addTabulation(data);
        } else if (this.type === "edit") {
          await this.updateTabulation(data);
        }
      }
      this.dialog = false;
    },
  },
};
</script>
